import React, { useEffect, useState } from "react";
import {
    errorMessage,
    formatAmount,
    formatDate,
    formatStatus,
    formatUsername,
} from "../../../util/Helpers";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../util/Permissions";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import { Button } from "react-bootstrap";
import { Permission } from "../../Common/layout/Permission";
import { ViewIcon } from "../../../util/Icons";
import ViewBillingModal from "./modals/ViewBillingModal";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { useDownloadBillingReportMutation } from "../../../../redux/apiSlice";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";

export const BillingsTable = ({ userGroup }) => {
    const [billingModal, setBillingModal] = useState({
        showViewBillingModal: false,
        details: null
    });

    const [
        downloadBillingReport,
        {
            isLoading: isLoadingBillingReport,
            isSuccess: isBillingReportGenerating,
        }
    ] = useDownloadBillingReportMutation()

    useEffect(() => {
        if (isBillingReportGenerating) {
            cogoToast.success(`Billing export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isBillingReportGenerating])

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setBillingModal({ ...billingModal, [modal]: !billingModal[modal] })
    }

    const viewBilling = details => {
        setBillingModal({ ...billingModal, showViewBillingModal: true, details });
    }

    const billingAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Permission permission={Permissions.SUBSCRIPTIONS} permissionType={PermissionType.READ}>
                    <Button
                        title="View Billing"
                        className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                        onClick={_ => viewBilling(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <ViewIcon />
                        </span>
                    </Button>
                </Permission>
            </span>
        )
    }

    return (
        <FilterGroup key={"billings"}>
            <div className="d-flex mb-4">
                <FilterGroup.Filter name="product" label="Type">
                    <FilterGroup.Option value="">All</FilterGroup.Option>
                    <FilterGroup.Option value="social-power-user">Social Power User</FilterGroup.Option>
                    <FilterGroup.Option value="market-insight-ngn">Market Insight</FilterGroup.Option>
                </FilterGroup.Filter>

                <div className="ml-3">
                    <FilterGroup.Filter name="status" label="Status">
                        <FilterGroup.Option value="">All</FilterGroup.Option>
                        <FilterGroup.Option value="COMPLETED">Completed</FilterGroup.Option>
                        <FilterGroup.Option value="PENDING">Pending</FilterGroup.Option>
                    </FilterGroup.Filter>
                </div>
            </div>

            <FilterGroup.Content className="mt-5">
                {({ filters }) => (
                    <Card>
                        <CardHeader title={`Billings`}>
                            <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                <CardHeaderToolbar>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={isLoadingBillingReport}
                                        onClick={() => downloadBillingReport({
                                            userGroup,
                                            startDate: filters?.startDate || "",
                                            endDate: filters?.endDate || "",
                                            status: filters?.status || "",
                                            type: filters?.type || "",
                                            format: "csv",
                                        })}
                                    >
                                        Export CSV
                                    </button>
                                </CardHeaderToolbar>
                            </Permission>
                        </CardHeader>

                        <CardBody>
                            <DynamicSimpleTable
                                key={`${userGroup}-billings`}
                                queryParams={
                                    `userGroup=${userGroup}`
                                    + `&limit=10`
                                    + `&product=${filters?.product || ""}`
                                    + `&status=${filters?.status || ""}`
                                }
                                searchBox={true}
                                source={{ url: `/subscriptions/billings` }}
                                columns={[
                                    { title: "REFERENCE", key: "ref" },
                                    { title: "PRODUCT", key: "product" },
                                    { title: "SUB KEY", key: "subKey" },
                                    { title: "USER", format: row => formatUsername(row.userId, row.username, null, row.accountId, "subscriptions") },
                                    { title: "CURRENCY", key: "currency" },
                                    { title: "PRICE", format: row => formatAmount(row.currency, row.price) },
                                    { title: "CHARGE AMOUNT", format: row => formatAmount(row.currency, row.chargeAmount) },
                                    { title: "STATUS", format: row => formatStatus(row.status) },
                                    { title: "CREATED AT", format: row => formatDate(row.created) },
                                    { title: "UPDATED AT", format: row => formatDate(row.updated) },
                                    { title: "", format: billingAction }
                                ]}
                                onError={(err) => cogoToast.error(errorMessage(err))}
                                refreshIcon={true}
                            />
                        </CardBody>
                    </Card>
                )}
            </FilterGroup.Content>

        </FilterGroup>

    );
};
